import { useState } from "react";
import { StalkerAdapter, type StalkerChannel } from "../../adapters/relayed/stalker";

export interface StalkerConnectStepProps {
  onConnected: (channels: StalkerChannel[], portal: string, mac: string) => void;
}

export function StalkerConnectStep({ onConnected }: StalkerConnectStepProps) {
  const [portal, setPortal] = useState("");
  const [mac, setMac] = useState("");
  const [error, setError] = useState<string | null>(null);
  const [loading, setLoading] = useState(false);

  const handleConnect = async () => {
    setError(null);
    setLoading(true);
    try {
      const result = await StalkerAdapter.listChannels(portal, mac);
      if (result.channels.length === 0) throw new Error("Portal returned no channels");
      onConnected(result.channels, portal, mac);
    } catch (e: unknown) {
      const msg = e instanceof Error ? e.message : "Failed to connect";
      setError(msg);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div style={{ padding: 24 }}>
      <h3>Connect Stalker Portal</h3>
      <input value={portal} onChange={(e) => setPortal(e.target.value)} placeholder="http://portal.example.com/c" style={{ width: "100%", padding: 8, marginBottom: 8 }} />
      <input value={mac} onChange={(e) => setMac(e.target.value)} placeholder="MAC address (00:1A:2B:3C:4D:5E)" style={{ width: "100%", padding: 8, marginBottom: 8 }} />
      <button onClick={handleConnect} disabled={loading || !portal || !mac}>
        {loading ? "Connecting..." : "Connect"}
      </button>
      {error && <div style={{ color: "#c00", marginTop: 12 }}>{error}</div>}
    </div>
  );
}
